<template>
    <div>
        <div class="pheadcontainer">
            <span style="font-size: 30px" class="phead">Join Us</span>
        </div>
        <hr />
        <br />
        <p>If you're interested in one of our <a href="/#/clubs">Clubs</a>, fill this form and apply to join us:</p>
        <div class="join-form">
            <input class="form-field" type="text" name="Name" placeholder="Name" id="name" />
            <input class="form-field" type="text" name="Age" placeholder="Age" id="age" />
            <input class="form-field" type="text" name="school" placeholder="School/Instituition" id="school" />
            <input class="form-field" type="email" name="email" placeholder="Email" id="email" />
            <input class="form-field" type="text" name="phone" placeholder="Phone" id="phone" />
            <input class="form-field" type="text" name="club" placeholder="Club" id="club" />
            <textarea class="form-field large" name="desc" rows="14" cols="10" wrap="soft" placeholder="Why do you wish to join us?" id="desc"> </textarea>
            <button class="joinsubmitbtn" id="submitbtn">Submit</button>
        </div>
    </div>

</template>
<script>
const isEmail = require('is-email');
import { init } from 'emailjs-com';
import emailjs from 'emailjs-com';
import party from "party-js";
init("user_eBpcavRO1KbKvfzij8deJ");

export default {
    mounted() {
        let name = document.getElementById("name")
        let age = document.getElementById("age")
        let school = document.getElementById("school")
        let email = document.getElementById("email")
        let phone = document.getElementById("phone")
        let club = document.getElementById("club")
        let desc = document.getElementById("desc")

        let btn = document.getElementById("submitbtn")

        btn.addEventListener("click", function () {
            party.confetti(this, {
                count: party.variation.range(30, 60),
            });
        });
        btn.addEventListener('click', ()=>{

            // send email and stuff
            let nameVal = name.value
            let ageVal = age.value
            let schoolVal = school.value
            let emailVal = email.value
            let phoneVal = phone.value
            let clubVal = club.value
            let descVal = desc.value

            if(!nameVal) return fieldAlert()
            if(!ageVal) return fieldAlert()
            if(!schoolVal) return fieldAlert()
            if(!emailVal) return fieldAlert()
            if(!phoneVal) return fieldAlert()
            if(!clubVal) return fieldAlert()
            if(!descVal) return fieldAlert()

            if(!isEmail(emailVal)) return alert("Please enter a valid email address.")
            
            var templateParams = {
                name: nameVal,
                age: ageVal,
                school: schoolVal,
                email: emailVal,
                mobile: phoneVal,
                club: clubVal,
                desc: descVal
            };
            emailjs.send('tacs-signup', 'tacsregister', templateParams)
            .then(function(response) {
                alert("You have sucessfully registered! We will get back to you on the specified email.")
                console.log(response)
            }, function(error) {
                alert("There was an error, please try again later.")
                console.log(error)
            });       

            
        })

        function fieldAlert() {
            alert("Please fill all the fields!")
        }
    }
}
</script>


<style scoped>
a {
    cursor: pointer;
}
  @media screen and (max-width: 720px) {
      .join-form {
          width: 90%;
      }

      .joinsubmitbtn {
          width: 100%;
      }
  }

</style>

